export const GLOBAL_STATE = 'ColorPalette'

export const COLOR_PALETTE = 'COLOR_PALETTE_ALL'
